module.exports = __webpack_public_path__ + "img/logma.2190c63d.png";